import React, { useState, useEffect } from 'react';
import { MessageCircle, X } from 'lucide-react';

export const FloatingWhatsApp = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const whatsappNumber = "56962942789";
  const whatsappMessage = encodeURIComponent("Hola! Me interesa conocer mas sobre sus servicios de IA y automatizacion.");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
      setIsVisible(scrollPercent > 15);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`, '_blank');
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      {/* Tooltip */}
      {showTooltip && (
        <div className="absolute bottom-16 right-0 bg-card border border-border rounded-xl shadow-lg p-4 w-52 animate-fade-in">
          <button
            onClick={() => setShowTooltip(false)}
            className="absolute -top-2 -right-2 w-6 h-6 bg-foreground text-background rounded-full flex items-center justify-center hover:bg-foreground/80 transition-colors"
          >
            <X className="h-3 w-3" />
          </button>
          <p className="text-sm font-medium text-foreground">
            Chatea con nosotros
          </p>
          <p className="text-xs text-muted-foreground mt-1">
            Respuesta en minutos
          </p>
        </div>
      )}

      {/* WhatsApp Button */}
      <button
        onClick={handleWhatsAppClick}
        onMouseEnter={() => setShowTooltip(true)}
        className="group relative w-14 h-14 bg-[#25D366] hover:bg-[#20bd5a] rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110"
        aria-label="Contactar por WhatsApp"
      >
        <MessageCircle className="h-6 w-6 text-white" />
        <span className="absolute w-14 h-14 rounded-full bg-[#25D366] animate-ping opacity-20" />
      </button>

      {/* Mobile label */}
      <div className="md:hidden absolute -top-8 right-0 bg-foreground text-background text-xs px-3 py-1 rounded-full whitespace-nowrap font-medium">
        Cotiza ahora
      </div>
    </div>
  );
};
